import request from "@/utils/request";

export async function passwordChange(data) {
  return request({
    url: `/api/account/password/change/`,
    method: `post`,
    data,
  });
}
